const style = () => ({
  poper: {
    zIndex: 1300,
  },
  unit: {
    fontSize: 14,
  },
  discountInput: {
    '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input': {
      '-moz-appearance': 'textfield',
    },
  },
})

export default style
